import React from 'react';
import { FeatureContainer, FeatureButton } from './RarityElements';

const Feature = () => {
  return (
    <FeatureContainer>
      <h1>Rarity</h1>
      <FeatureButton></FeatureButton>
      <p>Each Crypto Bear is special, but some are even more special than the rest.</p>

<p>From pirate hats to king, all crypto Bears attributes have a different rarity score. The combination of features each bear has builds its' total rarity score and overall rarity tier.</p>

<p>king tier are the rarest bears, showcasing the most unique features.</p>

<p>There are also five extra special unique bears to watch out for. If you find one of these, make sure to let us know!</p>
    </FeatureContainer>
  );
};

export default Feature;
